import { render, staticRenderFns } from "./OperaJobWindow.vue?vue&type=template&id=47870a87&"
import script from "./OperaJobWindow.vue?vue&type=script&lang=js&"
export * from "./OperaJobWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports